exports = module.exports = {
	_mode: "local",
	_env: "web",
	_isExtension: function() {
		if (this._env === "extension") {
			return true;
		} else {
			return false;
		}
	},
	setSettings: function(obj) {},
	set(obj) {
		return new Promise((resolve, reject) => {
			if (this._isExtension()) {
				browser.storage[this._mode].set(obj).then(resolve);
			} else {
				for (var property in obj) {
					if (obj.hasOwnProperty(property)) {
						window.localStorage.setItem(
							property,
							JSON.stringify(obj[property])
						);
					}
				}
				resolve();
			}
		});
	},
	get(key) {
		if (Array.isArray(key)) {
		} else {
			key = [key];
		}
		return new Promise((resolve, reject) => {
			if (this._isExtension()) {
				browser.storage[this._mode].get(key).then(resolve);
			} else {
				let data = {};
				let val = null;
				for (var i = 0; i < key.length; i++) {
					val = window.localStorage.getItem(key[i]);
					if (val) {
						try {
							data[key] = JSON.parse(val);
						} catch (err) {
							data[key] = val;
						}
					}
				}
				resolve(data);
			}
		});
	},
	getAll: function() {},
};
